"use strict";

exports.__esModule = true;
exports.WorkdaySelectorPopover = void 0;
var _core = require("@blueprintjs/core");
var _datetime = require("@blueprintjs/datetime");
var _icons = require("@blueprintjs/icons");
var _react = _interopRequireWildcard(require("react"));
var _dateFnsLocaleMapping = require("../../../Utils/dateFnsLocaleMapping");
var _dynamicMomentLocaleImports = require("../../../Utils/dynamicMomentLocaleImports");
var _utils = require("../../Calendar/utils");
var _Core = require("../../Core");
var _excluded = ["disabled", "placeholder", "selected", "minDate", "maxDate"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var localeKey = localStorage.getItem("vi-locale-key") || "en-us";
(0, _dynamicMomentLocaleImports.importMomentLocales)(localeKey);

/**
 * Allows a user to select a single workday from a popup calendar.
 */
var WorkdaySelectorPopover = exports.WorkdaySelectorPopover = /*#__PURE__*/function (_Component) {
  function WorkdaySelectorPopover() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      isOpen: false
    };
    _this.handleOpenClick = function () {
      _this.setState({
        isOpen: true
      });
    };
    _this.handleClose = function () {
      _this.setState({
        isOpen: false
      });
    };
    _this.handleChange = function (value, hasUserManuallySelectedDate) {
      if (value == null || !hasUserManuallySelectedDate) {
        return;
      }
      var onSelect = _this.props.onSelect;
      var workdayId = (0, _utils.getDate)(value);
      onSelect([workdayId]);
    };
    _this.getButtonText = function (value, placeholder, translate, intl, date) {
      return value ? intl.formatDate(date, {
        year: "numeric",
        month: "long",
        day: "2-digit"
      }) : placeholder || translate("WorkdaySelectorPopover.placeholder", "Select Workday");
    };
    return _this;
  }
  _inheritsLoose(WorkdaySelectorPopover, _Component);
  var _proto = WorkdaySelectorPopover.prototype;
  _proto.render = function render() {
    var _this2 = this;
    // eslint-disable-next-line no-unused-vars
    var _this$props = this.props,
      disabled = _this$props.disabled,
      placeholder = _this$props.placeholder,
      selected = _this$props.selected,
      minDate = _this$props.minDate,
      maxDate = _this$props.maxDate,
      extra = _objectWithoutPropertiesLoose(_this$props, _excluded);
    var value = selected.length > 0 ? selected[0] : null;
    var date = value;
    var min = minDate || (0, _utils.getMinDate)();
    var max = maxDate;
    return /*#__PURE__*/_react["default"].createElement("div", {
      "data-testid": "WorkdaySelector",
      style: Object.assign({
        marginLeft: "10px"
      }, extra == null ? void 0 : extra.style)
    }, /*#__PURE__*/_react["default"].createElement(_Core.Translator, null, function (_ref) {
      var translate = _ref.translate,
        intl = _ref.intl;
      return /*#__PURE__*/_react["default"].createElement(_core.Popover, {
        isOpen: _this2.state.isOpen,
        onClose: _this2.handleClose,
        content: /*#__PURE__*/_react["default"].createElement(_datetime.DatePicker, _extends({
          value: date,
          minDate: min,
          maxDate: max,
          onChange: _this2.handleChange,
          locale: _dateFnsLocaleMapping.dateFnsLocaleKeyMapping[localeKey]
        }, extra))
      }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
        disabled: disabled,
        "data-testid": "WorkdaySelector.selectorButton",
        icon: _icons.IconNames.CALENDAR,
        onClick: _this2.handleOpenClick,
        text: _this2.getButtonText(value, placeholder, translate, intl, date)
      }));
    }));
  };
  return WorkdaySelectorPopover;
}(_react.Component);